<div class="edit-profile-dialog">
    <div class="edit-profile-header">
        <div>
            <span class="edit-profile-eyebrow">
                MI CUENTA
            </span>
            <h2>
                Editar perfil
            </h2>
            <p>
                Actualiza los datos de tu cuenta.
            </p>
        </div>

        <button type="button" class="edit-profile-close" (click)="close()" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="edit-profile-body" [formGroup]="registerForm">

        <div class="form-grid">

            <div class="form-field form-field-full">
                <label>Nombre(s)</label>
                <input type="text" formControlName="names" placeholder="Nombre(s)">

                <span class="field-error" *ngIf="names?.invalid && names?.touched">
                    {{ getErrorMessage('names') }}
                </span>
            </div>

            <div class="form-field">
                <label>Apellido paterno</label>
                <input type="text" formControlName="last_name" placeholder="Apellido paterno">

                <span class="field-error" *ngIf="last_name?.invalid && last_name?.touched">
                    {{ getErrorMessage('last_name') }}
                </span>
            </div>

            <div class="form-field">
                <label>Apellido materno</label>
                <input type="text" formControlName="last_name2" placeholder="Apellido materno">

                <span class="field-error" *ngIf="last_name2?.invalid && last_name2?.touched">
                    {{ getErrorMessage('last_name2') }}
                </span>
            </div>

            <div class="form-field">
                <label>Teléfono</label>
                <input type="text" inputmode="numeric" maxlength="10" formControlName="phone" placeholder="10 dígitos">

                <span class="field-error" *ngIf="phone?.invalid && phone?.touched">
                    {{ getErrorMessage('phone') }}
                </span>
            </div>

            <div class="form-field">
                <label>Correo electrónico</label>
                <input type="email" formControlName="email" placeholder="correo@ejemplo.com">

                <span class="field-error" *ngIf="email?.invalid && email?.touched">
                    {{ getErrorMessage('email') }}
                </span>
            </div>

            <div class="form-field">
                <label>Fecha de nacimiento</label>

                <mat-form-field appearance="outline" class="material-date-field">
                    <input matInput [matDatepicker]="birthdatePicker" formControlName="birthdate" [max]="maxDate"
                        placeholder="dd/mm/aaaa">

                    <mat-datepicker-toggle matSuffix [for]="birthdatePicker">
                    </mat-datepicker-toggle>

                    <mat-datepicker #birthdatePicker></mat-datepicker>
                </mat-form-field>

                <span class="field-error" *ngIf="birthdate?.invalid && birthdate?.touched">
                    {{ getErrorMessage('birthdate') }}
                </span>
            </div>

            <div class="form-field">
                <label>Género</label>

                <select formControlName="gender">
                    <option value="">Selecciona una opción</option>
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                    <option value="O">Otro</option>
                </select>

                <span class="field-error" *ngIf="gender?.invalid && gender?.touched">
                    {{ getErrorMessage('gender') }}
                </span>
            </div>

            <div class="form-field" *ngIf="gender?.value === 'O'">

                <label>Especifica</label>

                <input type="text" formControlName="gender_value" placeholder="Especifica tu género">
            </div>

            <div class="form-field form-field-full">
                <label>Código postal</label>

                <input type="text" inputmode="numeric" maxlength="5" formControlName="main_zip_code"
                    placeholder="Código postal" (input)="searchDataZipCode()">

                <span class="field-error" *ngIf="main_zip_code?.invalid && main_zip_code?.touched">
                    {{ getErrorMessage('main_zip_code') }}
                </span>
            </div>

            <div class="form-field form-field-full">
                <label>Colonia</label>

                <select formControlName="locality_id" (change)="onSelectionLocality($event)">

                    <option value="">
                        Selecciona una colonia
                    </option>

                    <option *ngFor="let locality of (dataLocalities | async)" [value]="locality.id">
                        {{ locality.name }}
                    </option>
                </select>

                <span class="field-error" *ngIf="locality_id?.invalid && locality_id?.touched">
                    {{ getErrorMessage('locality_id') }}
                </span>
            </div>

            <div class="form-field">
                <label>Municipio</label>

                <input type="text" formControlName="municipality" readonly>
            </div>

            <div class="form-field">
                <label>Estado</label>

                <input type="text" formControlName="state" readonly>
            </div>

        </div>
    </div>

    <div class="edit-profile-actions">
        <button type="button" class="cancel-button" (click)="close()">
            Cancelar
        </button>

        <button type="button" class="save-profile-button" [disabled]="registerForm.invalid" (click)="updateProfile()">
            Guardar cambios
        </button>
    </div>
</div>